import React from 'react';
import DatahubAPI from '../../../api/DatahubAPI';
import CustomAutocomplete from 'components/Common/MUICustomAutocomplete';

interface IESGOpts {
  formValues: any;
  setFormValues: any;
  setCountryOpts: any;
  selectedIndex: string;
  countryOpts: any;
  countryData: any;
  listNameOpts: any;
  setListNameOpts: any;
  biteListPrimaryOpts: any;
  toClear: boolean;
}

const ESGOptions: React.FC<IESGOpts> = ({
  biteListPrimaryOpts,
  selectedIndex,
  formValues,
  setFormValues,
  countryOpts,
  setCountryOpts,
  listNameOpts,
  setListNameOpts,
  toClear,
}) => {
  const handleAgencySelect = async(e: any) => {
    const obj = {
      ...formValues,
      govtAgency: e,
      listName: [],
      country: [],
    };
    setFormValues(obj);
    if (obj && obj.govtAgency.length !== 0) {
      setListNameOpts({ isLoading: true, data: {} });
      setCountryOpts({ isLoading: true, data: {} });
      const res = await DatahubAPI.biteList({
        indexName: selectedIndex,
        govtAgency: obj.govtAgency,
      });
      const addedBuckets: any = [];
      if (res?.result) {
        res?.result?.result?.body?.aggregations?.countryAgg?.buckets.map(
          (bucket: any) => {
            addedBuckets.push(bucket.listNameAgg.buckets);
          },
        );
      }
      setListNameOpts({ isLoading: false, data: addedBuckets.flat() });
    }
  };

  const handleListNameSelect = async(e: any) => {
    const obj = {
      ...formValues,
      listName: e,
      country: [],
      state: [],
    };
    setFormValues(obj);
    if (obj && obj.listName.length !== 0) {
      setCountryOpts({ isLoading: true, data: {} });
      const res = await DatahubAPI.biteList({
        indexName: selectedIndex,
        listName: obj.listName,
      });
      const addedBuckets: any = [];
      if (res?.result) {
        res?.result?.result?.body?.aggregations?.countryAgg?.buckets.map(
          (bucket: any) => {
            bucket.listNameAgg.buckets.map((secondBucket: any) => {
              addedBuckets.push(secondBucket.countryAgg.buckets);
            });
          },
        );
      }
      setCountryOpts({ isLoading: false, data: addedBuckets.flat() });
    }
  };

  const handleCountrySelect = async(e: any) => {
    setFormValues({ ...formValues, country: e });
  };

  return (
    <div className='wl-dropdown-container'>
      {!biteListPrimaryOpts.isLoading && (
        <CustomAutocomplete
          options={biteListPrimaryOpts.data.countryAgg.buckets}
          placeholder='Agency'
          onChange={handleAgencySelect}
          toClear={toClear}
        />
      )}
      <CustomAutocomplete
        options={!listNameOpts.isLoading ? listNameOpts.data : []}
        placeholder='List Name'
        onChange={handleListNameSelect}
        toClear={toClear}
      />
      <CustomAutocomplete
        options={!countryOpts.isLoading ? countryOpts.data : []}
        placeholder='Country'
        onChange={handleCountrySelect}
        toClear={toClear}
      />
    </div>
  );
};

export default ESGOptions;
